import React from "react";
import SelectField from "./SelectField";
import {useSelector} from "react-redux";

function PhoneCodeField(props) {
    const phoneCodes = useSelector(state => state.dictionary.phoneCodes);

    const options = phoneCodes.map(data => ({
        label: data.value ? '+' + data.value : '',
        value: data.label,
        icon: <span className={`flag-icon flag-icon-${data.label} react-select__flag`} />
    }));

    return <SelectField {...props} options={options} />
}

export default PhoneCodeField